// Member article detail — uses the canonical ArticleRenderer (§31) then a
// comments section beneath (styled in the app's normal dark shell, not the
// article-surface, so members can see who is commenting without visual noise).

import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/modules/growing-circle/lib/api";
import ArticleRenderer from "./ArticleRenderer";
import CommentSection from "./CommentSection";

export default function MemberArticleDetail() {
  const { slug } = useParams();
  const [state, setState] = useState({ loading: true });
  useEffect(() => {
    let alive = true;
    api.get(`/articles/${slug}`).then(({ data }) => { if (alive) setState({ article: data.article, loading: false }); })
      .catch(() => { if (alive) setState({ error: true, loading: false }); });
    return () => { alive = false; };
  }, [slug]);
  if (state.loading) return <div className="min-h-[40vh] flex items-center justify-center text-muted-foreground text-sm">Loading…</div>;
  if (state.error || !state.article) return <div className="min-h-[40vh] flex items-center justify-center text-muted-foreground" data-testid="article-not-found">Article not found.</div>;
  const a = state.article;
  return (
    <div data-testid="member-article-detail">
      <ArticleRenderer fields={a.fields} publishedAt={a.publish_at || a.first_published_at} />
      <CommentSection slug={a.slug} articleId={a.id} />
    </div>
  );
}
